import * as Blockly from 'blockly/core';
import { expr } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['on_off'] = function (block: Blockly.Block): [string, number] {
        const value = block.getFieldValue('VALUE');
        return expr(value);
    };
}
